<app-breadcrumb [title]="'Liderazgo y Compromiso'" [items]="['Pesv']" [active_item]="'Liderazgo'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-verification-check me-2"></i>
      <h5 class="mb-0"><strong>LIDERAZGO Y COMPROMISO</strong></h5>
    </div>

    <div class="card-body">
      <ul ngbNav #nav="ngbNav" class="nav-tabs" [(activeId)]="tabActivo">
        <!-- TAB 1: REGISTRO ACTA -->
        <li [ngbNavItem]="1">
          <a ngbNavLink><strong>REGISTRO ACTA</strong></a>

          <ng-template ngbNavContent>
            <form [formGroup]="formLiderazgo">
              <div class="card-body p-2 p-md-3">
              <div class="row g-3">
                      <div class="col-md-3">
                        <label class="form-label fw-semibold">Consecutivo:<span class="text-danger"> *</span></label>
                        <input type="text" class="form-control" formControlName="consecutivo" readonly disabled />
                        <small class="text-dark d-block mt-1">Generado automáticamente por el sistema.</small>
                      </div>
                      
                    <div class="col-md-3">
                      <label class="form-label fw-semibold">
                        Fecha del Acta: <span class="text-danger">*</span>
                      </label>
                    
                      <input type="date" class="form-control" formControlName="fecha" [max]="fechaActual" />
                    </div>
                      <div class="col-md-3">
                        <label class="form-label fw-semibold">Versión: <span class="text-danger"> *</span></label>
                        <input type="text" class="form-control" formControlName="version" />
                      </div>
                      <div class="col-md-3">
                        <label class="form-label text-dark fw-semibold">Estado: <span class="text-danger"> *</span></label>
                        <select class="form-select" formControlName="estado">
                          <option *ngFor="let estado of estadosPolitica" [value]="estado.id">{{ estado.nombre }}</option>
                        </select>
                      </div>
                      
                     
                      <div class="col-12">
                        <label class="form-label fw-semibold">Observaciones:</label>
                        <textarea rows="4" class="form-control" formControlName="observaciones" placeholder="Ingrese observaciones si aplica..."></textarea>
                      </div>
                    </div>
                        <div class="border-0 shadow-sm">
                          <div class="mt-3">
                            <h6 class="fw-bold text-primary mb-3">
                              <i class="icofont icofont-file-pdf me-2"></i>
                              ACTA DE LIDERAZGO Y ALTA DIRECCIÓN - Documento PDF
                            </h6>
                        
                            <input type="file" class="d-none" id="fileInputActaPdf" accept=".pdf" (change)="onPdfFileSelected($event)" />
                        
                            <label for="fileInputActaPdf"
                              class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary border-2 rounded-3 cursor-pointer bg-light"
                              tabindex="0" (dragover)="onDragOverPdfActa($event)" (dragleave)="onDragLeavePdfActa($event)"
                              (drop)="onDropPdfActa($event)">
                        
                              <ng-container *ngIf="pdfFileSelected; else noFileActaPdf">
                                <i class="icofont icofont-file-pdf fs-1 text-danger mb-2"></i>
                                <div class="text-center">
                                  <div class="fw-bold text-primary">{{ pdfFileSelected?.name }}</div>
                                  <small class="text-secondary fw-medium">{{ formatFileSize(pdfFileSelected.size) }}</small>
                                </div>
                              </ng-container>
                        
                              <ng-template #noFileActaPdf>
                                <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
                                <h6 class="mb-1 text-primary">Cargar PDF</h6>
                                <small class="text-dark">Arrastre el archivo aquí o haga clic para seleccionarlo</small>
                              </ng-template>
                            </label>
                        
                            <div *ngIf="pdfFileSelected" class="d-flex justify-content-center mt-3">
                              <button class="btn btn-outline-danger px-4" type="button" (click)="removePdfActaSeleccionado()">
                                <i class="icofont icofont-trash me-2"></i>
                                Eliminar archivo
                              </button>
                            </div>
                        
                            <small class="text-secondary fw-medium d-block mt-2">
                              Solo se permite archivo PDF con un tamaño máximo de 10 MB.
                            </small>
                          </div>
                        </div>
            <div class="alert alert-info mt-4">
                  <div class="d-flex">
                    <i class="bi bi-info-circle-fill fs-4 me-3"></i>
                    <div>
                      <strong>Importante</strong>
                      <p class="mb-0 mt-1">Este módulo únicamente registra el documento oficial aprobado por la Alta Dirección. Si posteriormente se genera una nueva versión del acta, el sistema conservará el historial documental para efectos de auditoría y trazabilidad. SOLO DEBE TENER UNA ACTA VIGENTE</p>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-end gap-2 mt-4">
                  <button type="button" class="btn btn-outline-secondary">
                    <i class="bi bi-x-circle me-1"></i>Cancelar
                  </button>
                  <button type="button" class="btn btn-success"
                    [disabled]="formLiderazgo.invalid || (!editando && actaVigenteExiste) || cargando"
                    (click)="guardarActaLiderazgo()">
                     <span *ngIf="cargando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                     <i *ngIf="!cargando" class="bi" [ngClass]="editando ? 'bi-pencil-square' : 'bi-save'"></i>

                  {{ cargando ? 'Guardando...' : (editando ? 'Actualizar' : 'Guardar') }}
                  </button>
                </div>
              </div>

            
            </form>
          </ng-template>
        </li>

        <!-- TAB 2: HISTORIAL DE COMITÉS Y SUS INTEGRANTES -->
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong>HISTORIAL DE ACTAS</strong></a>

         <ng-template ngbNavContent>
  <div class="card-body p-2 p-md-3">
    <div class="card card-absolute rounded">

      <!-- Encabezado -->
      <div class="card-header bg-primary text-white d-flex align-items-center">
        <i class="icofont icofont-list me-2"></i>
        <h5 class="mb-0">
          <strong>LISTADO DE ACTAS DE LIDERAZGO</strong>
        </h5>
      </div>

      <div class="card-body">

        <!-- Tabla -->
        <div class="table-responsive">
          <table class="table table-hover table-bordered align-middle mt-3">

             <thead class="bg-primary text-white">
              <tr>
                <th class="text-center">CONSECUTIVO</th>
                <th class="text-center">FECHA</th>
                <th class="text-center">VERSIÓN</th>
                <th class="text-center">ESTADO</th>
                <th class="text-center">OBSERVACIONES</th>
                <th class="text-center" width="180">ACCIONES</th>
              </tr>
            </thead>

            <tbody>

              <tr *ngFor="let acta of historialActas | slice:(page - 1) * pageSize : page * pageSize">

                <td class="text-center">
                  {{ acta.consecutivo }}
                </td>

                <td class="text-center">
                  {{ acta.fecha | date:'dd/MM/yyyy' }}
                </td>

                <td class="text-center">
                  {{ acta.version }}
                </td>

                <td class="text-center">
                  <span
                    class="badge"
                    [ngClass]="getClaseEstado(acta.estadoDocumento.nombre)">
                    {{ acta.estadoDocumento.nombre }}
                  </span>
                </td>

                <td>
                  {{ acta.observaciones || 'N/A' }}
                </td>

                <td class="text-center">

                  <div class="d-flex justify-content-center gap-1">

                    <button
                      *ngIf="puedeEditarLiderazgo(acta)"
                      class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                      ngbTooltip="Editar"
                      (click)="editarLiderazgoDesdeHistorial(acta)">
                      <i class="icofont icofont-edit"></i>
                    </button>

                    <button
                      *ngIf="puedeRechazarLiderazgo(acta)"
                       class="btn btn-sm btn-outline-danger rounded-pill btn-rounded"
                      ngbTooltip="Inactivar"
                      (click)="inactivarLiderazgoDesdeHistorial(acta)">
                      <i class="icofont icofont-trash"></i>
                    </button>

                    <button
                       class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                      ngbTooltip="Visualizar documento"
                      (click)="VerDocumentoLiderazgo(acta.version)">
                      <i class="icofont icofont-printer"></i>
                    </button>

                    <button
                       class="btn btn-sm btn-outline-warning rounded-pill btn-rounded"
                      ngbTooltip="Descargar acta"
                      (click)="descargarDocumentoComite(acta.version)">
                      <i class="icon icon-download"></i>
                    </button>

                  </div>

                </td>

              </tr>

              <!-- Sin registros -->
              <tr *ngIf="historialActas.length === 0">
                <td colspan="6" class="text-center py-5 text-muted">
                  <i class="icofont icofont-info-circle fs-3 d-block mb-2"></i>
                  No existen actas registradas.
                </td>
              </tr>

            </tbody>

          </table>
        </div>

        <!-- Pie de tabla -->
        <div class="row align-items-center mt-3 gy-3">

          <!-- Registros por página -->
          <div class="col-lg-3 col-md-4">

            <div class="d-flex align-items-center">

              <label class="me-2 fw-semibold mb-0">
                Mostrar
              </label>

              <select
                class="form-select form-select-sm"
                style="width:90px"
                [(ngModel)]="pageSize"
                (ngModelChange)="page = 1">

                <option [ngValue]="5">5</option>
                <option [ngValue]="10">10</option>
                <option [ngValue]="20">20</option>
                <option [ngValue]="50">50</option>
                <option [ngValue]="100">100</option>

              </select>

              <span class="ms-2">
                registros
              </span>

            </div>

          </div>

          <!-- Información -->
          <div class="col-lg-5 col-md-4 text-center">

            <small class="text-muted">

              Mostrando

              <strong>
                {{ historialActas.length === 0 ? 0 : ((page - 1) * pageSize) + 1 }}
              </strong>

              -

              <strong>
                {{ finRegistro }}
              </strong>

              de

              <strong>
                {{ historialActas.length }}
              </strong>

              registros

            </small>

          </div>

          <!-- Paginación -->
          <div class="col-lg-4 col-md-4 d-flex justify-content-md-end justify-content-center">

            <ngb-pagination
              [(page)]="page"
              [pageSize]="pageSize"
              [collectionSize]="historialActas.length"
              [maxSize]="5"
              [rotate]="true"
              [boundaryLinks]="true"
              size="sm">

            </ngb-pagination>

          </div>

        </div>

      </div>

    </div>
  </div>
</ng-template>
        </li>

       
      </ul>

      <div [ngbNavOutlet]="nav" class="mt-3"></div>
    </div>
  </div>
</div>

 

